import { DragDropContext, Droppable, Draggable, GreyGripIcon, PageStyle } from '@/imports-files/pages/career/customize-career-page';
import ReOrderStyle from '@/styles/components/careers/add-section/_index.module.scss';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
export function ReOrderSection({formik, customizeCareerAction, formRef}){
const {t} = useTranslation()
  function render_page_section(page_section, index, formik, customizeCareerAction, isPreview) {
    let section_type = page_section.type
    switch(section_type){
    case 'about':
      return <div className = {`${ReOrderStyle.ReOrder__AboutOptionCard}`}>
        <div className = {`${ReOrderStyle.ReOrder__SubTitle}`}>
          <h3>{parse(page_section.career_about_section_attributes.title)}</h3>
        </div>
        {!isPreview && <div className = {`${ReOrderStyle.ReOrder__RemoveSection}`}>
          <span onClick={(event) => {
            customizeCareerAction.removeSection(formik, page_section)
          }}><img src ='/icons/career_icons/grey_delete.svg'></img></span>
        </div>}
      </div>
      break;
    case 'benefit':
      return <div className = {`${ReOrderStyle.ReOrder__BenefitOptionCard}`}>
        <div className = {`${ReOrderStyle.ReOrder__SubTitle}`}>
          <h3>{parse(page_section.career_benefit_section_attributes.title)}</h3>
        </div>
        {!isPreview && <div className = {`${ReOrderStyle.ReOrder__RemoveSection}`}>
          <span onClick={(event) => {
            customizeCareerAction.removeSection(formik, page_section)
          }}><img src ='/icons/career_icons/grey_delete.svg'></img></span>
        </div>}
      </div>
      break;
    case 'team':
      return <div className = {`${ReOrderStyle.ReOrder__MeetOurTeamOptionCard}`}>
        <div className = {`${ReOrderStyle.ReOrder__SubTitle}`}>
          <h3>{parse(page_section.career_team_section_attributes.title)}</h3>
        </div>
        {!isPreview && <div className = {`${ReOrderStyle.ReOrder__RemoveSection}`}>
          <span onClick={(event) => {
            customizeCareerAction.removeSection(formik, page_section)
          }}><img src ='/icons/career_icons/grey_delete.svg'></img></span>
        </div>}
      </div>
      break;
    case 'gallery':
      return <div className = {`${ReOrderStyle.ReOrder__GalleryOptionCard}`}>
        <div className = {`${ReOrderStyle.ReOrder__SubTitle}`}>
          <h3>{parse(page_section.career_gallery_section_attributes.title)}</h3>
        </div>
        {!isPreview && <div className = {`${ReOrderStyle.ReOrder__RemoveSection}`}>
          <span onClick={(event) => {
            customizeCareerAction.removeSection(formik, page_section)
          }}><img src ='/icons/career_icons/grey_delete.svg'></img></span>
        </div>}
      </div>
      break;
    }
  }

  function render_static_section(label){
    return <div className = {`${ReOrderStyle.ReOrder__DefaultOptionCard}`}>
        <div className = {`${ReOrderStyle.ReOrder__SubTitle} ml0`}>
          <h3>{label}</h3>
        </div>
      </div>
  }
  return(
    <div className = {`${ReOrderStyle.ReOrder}`}>
      {render_static_section(t('career:hero_section'))}
      {render_static_section(t('career:job_openings'))}
      <div className = {`DragandDropArea`}>
        <DragDropContext onDragEnd={async(result) => await customizeCareerAction.onDragEnd(result, formRef, formik)}>
          <Droppable droppableId="SectionsList">
            {(provided, snapshot) => (
              <div
                className={`${snapshot.isDraggingOver ? "dragactive" : ""}`}
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
              {
                formik.values.page_sections_attributes.map((page_section, index) => {
                  {return (page_section.type != 'job' &&
                    <Draggable draggableId={page_section.id.toString()} index={index} key={page_section.id.toString()}>
                        {(provided, snapshot) => (
                        <div className={`${PageStyle.Interview__FormRowHeading} ${PageStyle.DragAndDrop} ${snapshot.isDragging ? "drag" : ""}`}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}>
                          <div className={`${PageStyle.DragAndDrop__CursorHandle}`}><GreyGripIcon/></div>
                          {render_page_section(page_section, index, formik, customizeCareerAction)}
                        </div>
                        )}
                    </Draggable>
                    )
                  }}
                )
              }
              {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      {render_static_section(t('career:footer'))}
    </div>
  )
}